__turbopack_context__.v({
  "active": "MenuIcon-module__Ty5w4q__active",
  "instantActive": "MenuIcon-module__Ty5w4q__instantActive",
  "menuIcon": "MenuIcon-module__Ty5w4q__menuIcon",
});
